import { SetListenerIfc } from './SetListenerIfc';
import { BitBoardEntity } from '../utils/BitBoardEntity';

export class DummySetListener implements SetListenerIfc{
    constructor() 
    {
        
    }
    
    isSetListener():boolean{
        return true;
    }
    public begin():void { }
    
    public end():void {}
    
    public reset():void {}
    
    public addRecord( id:number ):void {}
    public addRecords( ids:Array<number> ):void {}
    
    public deleteRecord( id:number ):void {}
    public deleteRecords( ids:Array<number> ):void {}

    public cellsUpdated( colls:BitBoardEntity, id:number ):void {}

    public setContainerMetaData( name:String, value:string ):void {}
    public setContainerMetaDatas( names:Array<string>, values:Array<string>):void {}
    public removeContainerMetaDatas( names:Array<string> ):void {}
    public removeMetaData( name:String ):void {}
}
